module.exports = __webpack_public_path__ + "static/img/IMG_20160830_213216.b5d42d92.jpg";